import { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  Typography,
  Button,
  FormControl,
  Switch,
  Checkbox,
  Divider,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { manualRegress, getInvoiceByInvoiceID } from "API/swesum";
import dayjs from "dayjs";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: 4,
  padding: 4,
  width: "100%",
  minWidth: 500,
  height: "100%",
};

export default function RegressModal({ invoice, open, setInvoice, onClose }) {
  const [loading, setLoading] = useState(false);

  const { openSuccess, openError } = usePopupNotificationContext();

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const res = await manualRegress(invoice.Id);

      if (res) {
        if (res.data.Status === "error") {
          openError(res.data.Message);
          return;
        }
        const updatedInvoice = await getInvoiceByInvoiceID(invoice?.Id);
        setInvoice(updatedInvoice);
        openSuccess("Återköp lyckades");
      }
    } catch (error) {
      openError("Något gick fel");
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <>
      <Dialog open={open}>
        <Box sx={style}>
          <Typography variant="h5" fontWeight={"bold"}>
            Vill utföra återköp av fakturan?
          </Typography>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={5}
            justifyContent={"space-around"}
            height={55}
            width={"100%"}
          >
            <Button
              sx={{
                backgroundColor: "transparent",
                outline: "1px solid #1976d2",
                color: "#1976d2",
                width: "100%",
              }}
              onClick={() => onClose()}
            >
              Avbryt
            </Button>
            <LoadingButton
              variant="contained"
              onClick={handleConfirm}
              loading={loading}
              sx={{
                backgroundColor: "#1976d2",
                color: "white",
                width: "100%",
              }}
            >
              Bekräfta
            </LoadingButton>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}
